const items = [
  { icon: 'ri-global-line', title: 'Ships to 50+ Countries', desc: 'Worldwide FOB delivery' },
  { icon: 'ri-shield-check-line', title: 'Mill Certified', desc: 'SGS & TUV inspected' },
  { icon: 'ri-bank-card-line', title: 'L/C & T/T Accepted', desc: 'Flexible payment terms' },
  { icon: 'ri-time-line', title: 'Reply in 2 Hours', desc: 'Mon–Fri, 9AM–6PM CST' },
];

export default function TrustBar() {
  return (
    <section className="bg-white border-b border-gray-100">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-gray-100">
          {items.map((item, i) => (
            <div
              key={item.title}
              className={`flex flex-col sm:flex-row items-center gap-3 px-4 py-5 text-center sm:text-left ${i % 2 === 0 ? '' : ''}`}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: '#0a2342' }}>
                <i className={`${item.icon} text-white text-lg`} />
              </div>
              <div>
                <div className="text-sm font-black text-gray-900">{item.title}</div>
                <div className="text-xs text-gray-500 mt-0.5">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
